export enum UserRole {
  ADMIN = "Admin",
  SUPERVISOR = "Supervisor",
  CONTENT_MANAGER = "ContentManager",
  EMPLOYEE = "Employee",
}

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.ADMIN]: "Administrador",
  [UserRole.SUPERVISOR]: "Supervisor",
  [UserRole.CONTENT_MANAGER]: "Manejador de Contenidos",
  [UserRole.EMPLOYEE]: "Empleado",
};

